import * as firebase from "firebase/app";
import "firebase/messaging";
import { api } from "./apiService";
import { showSnackbar } from "./utils";

// Initialize Firebase
const config = {
  apiKey: "AIzaSyANSyNOTnUw55H01j_oBL7pRH8ln6RhbBg",
  authDomain: "ptsp-test.firebaseapp.com",
  databaseURL: "https://ptsp-test.firebaseio.com",
  projectId: "ptsp-test",
  storageBucket: "ptsp-test.appspot.com",
  messagingSenderId: "557174527097"
};
firebase.initializeApp(config);

// Retrieve Firebase Messaging object.
export const messaging = firebase.messaging();

// Add the public key generated from the console here.
export const initMessaging = () => {
  console.log("Initializing messaging, ");
  messaging.usePublicVapidKey(
    "BKbdRweIgAOzi9NOiMhIEnUqsRKk1q2baalb9kfZ6TfsHF8Rd-6_s7opgWLr-WGnpZ3nNLfrbV2by0VuR1dPchY"
  );

  messaging.onMessage(function(payload){
    // Add notifications to store
    // Show notificationn if page already open
    console.log('onMessage', {...payload})
    const {body, click_action} = payload.notification
    showSnackbar({message:body, url:click_action, commit:true})
  });

  messaging.onTokenRefresh(function() {
    messaging
      .getToken()
      .then(function(refreshedToken) {
        console.log("Token refreshed.");
        // Indicate that the new Instance ID token has not yet been sent to the
        // app server.
        setTokenSentToServer(false);
        // Send Instance ID token to app server.
        sendTokenToServer(refreshedToken);
      })
      .catch(function(err) {
        console.log("Unable to retrieve refreshed token ", err);
        showToken("Unable to retrieve refreshed token ", err);
      });
  });
};
export const requestPermission = () => {
  console.log("Requesting permission...");
  // [START request_permission]
  messaging
    .requestPermission()
    .then(function() {
      console.log("Notification permission granted.");
      // Get Instance ID token. Initially this makes a network call, once retrieved
      // subsequent calls to getToken will return from cache.
      messaging
        .getToken()
        .then(function(currentToken) {
          if (currentToken) {
            console.log(currentToken);
            sendTokenToServer(currentToken);
          } else {
            // Show permission request.
            console.log(
              "No Instance ID token available. Request permission to generate one."
            );
            // Show permission UI.
            setTokenSentToServer(false);
          }
        })
        .catch(function(err) {
          console.log("An error occurred while retrieving token. ", err);
          // showToken('Error retrieving Instance ID token. ', err);
          setTokenSentToServer(false);
        });
    })
    .catch(function(err) {
      console.log("Unable to get permission to notify.", err);
    });
  // [END request_permission]
};

export const deleteToken = () => {
  // Delete Instance ID token.
  // [START delete_token]
  messaging
    .getToken()
    .then(function(currentToken) {
      messaging
        .deleteToken(currentToken)
        .then(function() {
          console.log("Token deleted.");
          setTokenSentToServer(false);
          // [START_EXCLUDE]
          // Once token is deleted update UI.
          resetUI();
          // [END_EXCLUDE]
        })
        .catch(function(err) {
          console.log("Unable to delete token. ", err);
        });
      // [END delete_token]
    })
    .catch(function(err) {
      console.log("Error retrieving Instance ID token. ", err);
      // showToken("Error retrieving Instance ID token. ", err);
    });
};

export const sendTokenToServer = currentToken => {
  if (!isTokenSentToServer()) {
    console.log("Sending token to server...");
    // TODO(developer): Send the current token to your server.
    const tokenJSON = JSON.stringify({
      registration_id: currentToken,
      type: "web"
    });
    api
      .post("/devices/", tokenJSON)
      .then(console.log("Token Sent"))
      .catch(err => {
        console.log(err);
      });
    setTokenSentToServer(true);
  } else {
    console.log(
      "Token already sent to server so won't send it again " +
        "unless it changes"
    );
  }
};

function isTokenSentToServer() {
  return window.localStorage.getItem("sentToServer") === "1";
}

export const setTokenSentToServer = sent => {
  window.localStorage.setItem("sentToServer", sent ? "1" : "0");
};
